import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

export interface SocialLink { label: string; url: string }
export interface FooterLink { name: string; path: string }
export interface FooterColumn { title: string; links: FooterLink[] }

export interface SiteSettings {
  companyName?: string;
  email?: string;
  phone?: string;
  address?: string;
  tagline?: string;
  footer_address?: string;
  footer_note?: string;
  top_bar_note?: string;
  socials?: SocialLink[];
  footer_columns?: FooterColumn[];
  legal_links?: FooterLink[];
  nav?: any[];
}

/**
 * Lit la ligne unique de configuration globale du site (table `settings`).
 * Renvoie null tant que non chargée → les composants utilisent leurs valeurs de repli.
 */
export function useSiteSettings(): SiteSettings | null {
  const [settings, setSettings] = useState<SiteSettings | null>(null);
  useEffect(() => {
    let active = true;
    if (!supabase) return;
    supabase
      .from('settings')
      .select('*')
      .limit(1)
      .maybeSingle()
      .then(({ data }) => {
        if (active && data) setSettings(data as SiteSettings);
      });
    return () => {
      active = false;
    };
  }, []);
  return settings;
}
